import { render } from "./Cassiopeia.vue?vue&type=template&id=6e5a6d66&ts=true"
import script from "./Cassiopeia.vue?vue&type=script&lang=ts"
export * from "./Cassiopeia.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__